import { PER_PAGE } from "../../components/constants";
import { CLOSE_LOADER, OPEN_LOADER } from "../actions/appActions";
import {
  SET_CLASS_GROUPS,
  SET_LANGUAGES,
  SET_STUDENT_DATA,
  SET_REGISTRATION_PENDING_STUDENTS,
  SET_STUDENTS_LIST,
  SET_PAYMENT_STATUSES,
  SET_SECTIONS,
  SET_BRANCHES,
  SET_PAYMENT_DUE_LIST,
  FEE_STRUCTURE,
  STATES_LIST,
  CLASS_ROOMS_LIST,
  UPDATE_STUDENTS_LIST,
  RESET_STUDENT_DATA,
  STUDENT_HISTORY,
  STUDENT_PAYMENT_HISTORY,
  STUDENT_ADMISSION_FORWARD_CLASS_GROUPS,
  YEARS_LIST,
  EMAIL_AVAILABILITY,
  INSTALLMENTS_LIST,
  RESET_STUDENTS_LIST,
  STUDENT_DUE_AMOUNT,
  SET_BLOOD_GROUPS,
  UPDATE_PER_PAGE,RESET_PAYMENT_DUE_LIST,ASSIGN_CLASS_ROOM, RESET_REGISTRATION_PENDING_STUDENTS
} from "../actions/studentActions";
const initialState = {
  classGroupsList: [],
  languagesList: [],
  studentProfileDetails: {},
  studentProfiles: [],
  pendingRegStudentsList: [],
  loader: false,
  pagination: {
    perPage: PER_PAGE,
    totalItems: 0,
    currentPage: 0,
    totalPages:0
  },
  branchesList: [],
  sectionsList: [],
  paymentStatusesList: [],
  paymentDueList: [],
  statesList: [],
  classRoomsList: [],
  studentHistoryData: [],
  studentPaymentHistoryData: [],
  admissionForwardClassGroups: [],
  yearsList: [],
  isEmailAvailable: false,
  installmentsData: [],
  dueAmount:0,
  bloodGroupsList:[]
};

export const studentReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CLASS_GROUPS:
      return {
        ...state,
        classGroupsList: action.payload,
      };
    case SET_BRANCHES:
      return {
        ...state,
        branchesList: action.payload,
      };
    case SET_SECTIONS:
      return {
        ...state,
        sectionsList: action.payload,
      };
    case SET_PAYMENT_STATUSES:
      return {
        ...state,
        paymentStatusesList: action.payload,
      };
    case SET_LANGUAGES:
      return {
        ...state,
        languagesList: action.payload,
      };
    case SET_STUDENT_DATA:
      return {
        ...state,
        studentProfileDetails: action.payload,
      };
    case SET_REGISTRATION_PENDING_STUDENTS:
      console.log(action.payload)
      return {
        ...state,
        totalCount: action.payload.totalCount,
        // pendingRegStudentsList: state.pendingRegStudentsList.concat(action.payload.studentData),
        pendingRegStudentsList: action.payload.studentData,
        pagination:{
          totalItems: action.payload.totalItems,
          totalPages: action.payload.totalPages,
          currentPage: action.payload.currentPage,
          perPage:PER_PAGE
        }
      };
    case SET_STUDENTS_LIST:
      return {
        ...state,
        studentProfiles: state.studentProfiles.concat(action.payload.studentData),
        pagination:{
          totalItems: action.payload.totalItems,
          totalPages: action.payload.totalPages,
          currentPage: action.payload.currentPage,
          perPage:PER_PAGE
        }
      };
    case SET_PAYMENT_DUE_LIST:
      console.log(action.payload)
      return {
        ...state,
        paymentDueList: state.paymentDueList.concat(action.payload.studentPaymentDue),
        pagination:{
          totalItems: action.payload.totalItems,
          totalPages: action.payload.totalPages,
          currentPage: action.payload.currentPage,
          perPage:PER_PAGE
        }
      };
    case STATES_LIST:
      return {
        ...state,
        statesList: action.payload,
        // }
      };
    case CLASS_ROOMS_LIST:
      return {
        ...state,
        classRoomsList: action.payload,
        // }
      };
    case OPEN_LOADER:
      return {
        ...state,
        loader: action.payload,
      };
    case CLOSE_LOADER:
      return {
        ...state,
        loader: action.payload,
      };
    case UPDATE_STUDENTS_LIST:
      return {
        ...state,
        studentProfiles: action.payload,
      };
    case RESET_STUDENT_DATA:
      return {
        ...state,
        studentProfileDetails: action.payload,
      };
    case STUDENT_HISTORY:
      return {
        ...state,
        studentHistoryData: action.payload,
      };
    case STUDENT_PAYMENT_HISTORY:
      return {
        ...state,
        studentPaymentHistoryData: action.payload,
      };
    case STUDENT_ADMISSION_FORWARD_CLASS_GROUPS:
      return {
        ...state,
        admissionForwardClassGroups: action.payload,
      };
    case YEARS_LIST:
      return {
        ...state,
        yearsList: action.payload,
      };
    case EMAIL_AVAILABILITY:
      return {
        ...state,
        isEmailAvailable: action.payload,
      };
    case INSTALLMENTS_LIST:
      return {
        ...state,
        installmentsData: action.payload,
      };
    case RESET_STUDENTS_LIST:
      return {
        ...state,
        studentProfiles: action.payload,
        pagination:{
          totalItems: 0,
          totalPages: 0,
          currentPage: 0,
          perPage:PER_PAGE
        }
      };
      case STUDENT_DUE_AMOUNT:
        return {
          ...state,
          dueAmount: action.payload,
        };
      case SET_BLOOD_GROUPS:
        return {
          ...state,
          bloodGroupsList: action.payload,
        };
        case UPDATE_PER_PAGE:
          console.log(action.payload)
          return {
            ...state,
            pagination:{
              totalItems: state.pagination.totalItems,
              totalPages: state.pagination.totalPages,
              currentPage: state.pagination.currentPage,
              perPage: action.payload,
            }
          };
          case RESET_PAYMENT_DUE_LIST:
            console.log(action.payload)
            return {
              ...state,
              paymentDueList: [],
              pagination:{
                totalItems: action.payload.totalItems,
                totalPages: action.payload.totalPages,
                currentPage: action.payload.currentPage,
                perPage:PER_PAGE
              }
            };
            case ASSIGN_CLASS_ROOM:
              return {
                ...state,
                studentProfiles: action.payload.studentData,
              }
              case RESET_REGISTRATION_PENDING_STUDENTS:
      console.log(action.payload)
      return {
        ...state,
        totalCount: 0,
        pendingRegStudentsList: [],
        pagination:{
          totalItems: 0,
          totalPages: 0,
          currentPage: 0,
          perPage:PER_PAGE
        }
      };
    default:
      return state;
  }
};
